// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { AdminApi } from '../types/admin.types';
import { adminHttpApi } from './admin.api';
import { adminMockApi } from './admin.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const adminApi: AdminApi = useMock ? adminMockApi : adminHttpApi;
